import { connect } from 'react-redux';

import DynamicField, { DynamicFieldProps } from './DynamicField';
import { getDynamicFieldProps } from 'modules/common/selectors';

const ConnectedDynamicField = connect(getDynamicFieldProps)(DynamicField);

export type { DynamicFieldProps };
export { DynamicField, ConnectedDynamicField };
